import * as React from 'react';
import clx from 'classnames';
import { Col, Row } from 'antd';
import { ColProps } from 'antd/lib/col';

export interface PageDesktopOnlyRowProps extends ColProps {}

/**
 * Colonna principale della pagina frontend con larghezza responsive
 */
export function PageDesktopOnlyRow(props: PageDesktopOnlyRowProps) {
  return (
    <Row>
      <Col xs={{ span: 0 }} md={{ span: 24 }} {...props} />
    </Row>
  );
}
